import { render, staticRenderFns } from "./TemplatesIndex.vue?vue&type=template&id=e07fe854&scoped=true&"
import script from "./TemplatesIndex.vue?vue&type=script&lang=js&"
export * from "./TemplatesIndex.vue?vue&type=script&lang=js&"
import style0 from "./TemplatesIndex.vue?vue&type=style&index=0&id=e07fe854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07fe854",
  null
  
)

export default component.exports